import SideBar from "./SideBar";
import Content from "./Content";
import ContentRenewal from "./ContentRenewal";
import DrawerContent from "./DrawerContent";
import FooterMobile from "./FooterMobile";

export { Content, DrawerContent, SideBar, FooterMobile, ContentRenewal };
